import { Section, P } from "./Primitives";

const steps = [
  { t: "Dicembre 2026", h: "Firma", d: "Sottoscrizione dell'accordo e prima tranche (40%). Raccolta di listini, ricette e anagrafiche." },
  { t: "Gennaio 2027", h: "Avvio", d: "Configurazione di Synapse OS su laboratorio e 7 punti vendita. Formazione del personale." },
  { t: "Febbraio 2027", h: "Collaudo", d: "Verifica congiunta in due sedi pilota, estensione a tutto il gruppo e seconda tranche (30%)." },
  { t: "Marzo 2027", h: "Lancio", d: "Pubblicazione dell'App, apertura del Portale B2B e avvio delle campagne di Fase 1. Terza tranche (30%)." },
];

export const Closing = () => (
  <Section id="chiusura" num="07" kicker="Prossimi passi" title="Dalla firma al lancio in tre mesi">
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
      {steps.map((s, i) => (
        <div key={s.h} className="step avoid-break" data-testid={`next-step-${i + 1}`}>
          <div className="font-display text-gold text-3xl mb-2">{i + 1}</div>
          <div className="kicker">{s.t}</div>
          <div className="font-display text-xl text-navy mt-1 mb-2">{s.h}</div>
          <div className="text-sm leading-relaxed text-[var(--ink-soft)]">{s.d}</div>
        </div>
      ))}
    </div>
    <P>
      Con la firma entro <strong>dicembre 2026</strong>, App e Portale B2B sono operativi a marzo 2027: in tempo per la <strong>Pasqua aziendale</strong> (28 marzo 2027).
      Restano poi sei mesi interi per costruire il portafoglio clienti prima delle strenne di Natale 2027.
      Le condizioni “Partner Fondatore” sono valide <strong>30 giorni</strong> dalla data del documento (novembre 2026).
    </P>
    <div className="contact avoid-break" data-testid="contact-block">
      <div>
        <div className="kicker !text-[var(--gold-light)] mb-3">PartnerTech</div>
        <div className="font-display text-3xl text-[var(--cream)]">Cristian D'Agostino</div>
        <div className="text-sm text-[rgba(247,241,230,0.7)] mt-1">Consulente · Referente del progetto Synapse OS per Bella Napoli</div>
      </div>
      <div className="text-sm text-[rgba(247,241,230,0.82)] sm:text-right">
        Importi IVA esclusa.
        <br />
        Stime di mercato non vincolanti.
        <br />
        Documento riservato e confidenziale.
      </div>
    </div>
  </Section>
);
